import { jsx as _jsx } from "react/jsx-runtime";
import { useAnimationFrame } from '@a-type/ui';
import { useRef } from 'react';
import { boundsRegistry } from './bounds.js';
import { useDndStore } from './dndStore.js';
import { gesture } from './gestureStore.js';
import { TAGS } from './tags.js';
export function DebugView({}) {
    const ref = useRef(null);
    useAnimationFrame(() => {
        const ctx = ref.current?.getContext('2d');
        if (!ctx)
            return;
        ctx.canvas.width = ctx.canvas.clientWidth;
        ctx.canvas.height = ctx.canvas.clientHeight;
        ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
        ctx.lineWidth = 1;
        for (const [id, entry] of boundsRegistry.__entries) {
            const { bounds: region, tags } = entry;
            let color = tags[TAGS.DROPPABLE]
                ? '#ff0000'
                : id === useDndStore.getState().dragging
                    ? '#ffff00'
                    : '#0000ff';
            if (entry.measuredAt < Date.now() - 1000) {
                color += '80'; // faded color for stale entries
            }
            else {
                color += 'ff'; // full opacity for recent entries
            }
            ctx.strokeStyle = color;
            ctx.strokeRect(region.x, region.y, region.width, region.height);
            ctx.fillStyle = color;
            ctx.fillText(id, region.x + 5, region.y + 15);
        }
        if (gesture.active) {
            ctx.fillStyle = 'orange';
            ctx.fillRect(gesture.currentRaw.x - 5, gesture.currentRaw.y - 5, 10, 10);
        }
    });
    return (_jsx("canvas", { style: {
            position: 'fixed',
            inset: 0,
            width: '100%',
            height: '100%',
            zIndex: 999999,
            pointerEvents: 'none',
            opacity: 0.5,
        }, ref: ref }));
}
//# sourceMappingURL=DebugView.js.map